import React from 'react';
import './HowWeWork.css';

const HowWeWork = () => {
  const steps = [
    {
      icon: '🔍',
      step: 'STEP 01',
      title: 'Discover',
      description: 'Understand your business context, data landscape, and strategic objectives through deep stakeholder engagement.'
    },
    {
      icon: '💡',
      step: 'STEP 02',
      title: 'Design',
      description: 'Architect tailored solutions combining data engineering, AI, and governance best practices for your industry.'
    },
    {
      icon: '🚀',
      step: 'STEP 03',
      title: 'Deliver',
      description: 'Implement with precision — production-ready solutions deployed on time, with full transparency and support.'
    },
    {
      icon: '↗',
      step: 'STEP 04',
      title: 'Evolve',
      description: 'Continuously optimise, scale, and adapt solutions as your business and regulatory landscape evolves.'
    }
  ];

  return (
    <section id="how-we-work" className="section section-alt how-we-work-section">
      <div className="container">
        <div className="section-header">
          <h2>How We Work</h2>
          <p>A proven methodology for delivering meaningful outcomes through intelligent AI solutions.</p>
        </div>
        <div className="timeline">
          {steps.map((step, index) => (
            <div key={index} className="timeline-item active">
              <div className="timeline-icon">{step.icon}</div>
              <div className="timeline-content">
                <span>{step.step}</span>
                <h3>{step.title}</h3>
                <p>{step.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowWeWork;
